import { render, staticRenderFns } from "./HKDoor.vue?vue&type=template&id=28b249be&scoped=true&"
import script from "./HKDoor.vue?vue&type=script&lang=js&"
export * from "./HKDoor.vue?vue&type=script&lang=js&"
import style0 from "./HKDoor.vue?vue&type=style&index=0&id=28b249be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b249be",
  null
  
)

export default component.exports